/* eslint semi: "off" */
/* eslint react/jsx-filename-extension: "off" */
/* eslint react/prop-types: "off" */
/* eslint no-console: "off" */
/* eslint jsx-a11y/click-events-have-key-events: "off" */
/* eslint jsx-a11y/no-noninteractive-element-interactions: "off" */
/* eslint jsx-a11y/anchor-has-content: "off" */
/* eslint react/no-multi-comp: "off" */
/* eslint no-underscore-dangle: "off" */
import React, { Component, useEffect } from 'react';
import { useStateValue } from './components/stateProvider/stateProvider';

import firebase from 'firebase';
import 'firebase/auth';
import 'firebase/database';


import { bindActionCreators, compose } from 'redux'
import { connect } from 'react-redux';
import { firebaseConnect } from 'react-redux-firebase'

import { Route, Switch, Link, withRouter } from 'react-router-dom'

import MuiThemeProvider from 'material-ui/styles/MuiThemeProvider';
import getMuiTheme from 'material-ui/styles/getMuiTheme';
import lightBaseTheme from 'material-ui/styles/baseThemes/lightBaseTheme';
import {
  Card,
  CardActions,
  CardHeader,
  CardMedia,
  CardTitle,
} from 'material-ui/Card';
import FlatButton from 'material-ui/FlatButton';

import IconNotificationLiveTv from 'material-ui/svg-icons/notification/live-tv';
import IconActionViewList from 'material-ui/svg-icons/action/view-list';

import logo from './logo.png';
import './styles.css';

import { command as commandActions } from './redux/actions'

import { Projector } from './components/projector'
import { RemoteControl } from './components/remote'
import { Receptor } from './components/receptor'
import { Partner } from './components/legacy-partner';
import { Component as NewParner } from './components/partner';

import { Lab } from './lab/components';

import { contextA } from './redux/store/configureStore';

const APP_VERSION = '1.0.1';
const AppHeaderWrapper = (props) => {
  const [{ theme }, dispatch] = useStateValue();
  const { children } = props
  return (
    <div className="h-48 p-4 text-white bg-gray-700">
      { children }  <button onClick={() => dispatch({ type: 'TOGGLE_THEME' })}>{ theme }</button>
    </div>
  )
}

const AppWrapper = (props) => {
  const { children } = props
  return (
    <div className="text-center">
      { children }
    </div>
  )
}

const PartnerListContainer = (props) => {
  const { children } = props
  return (
    <ul className="relative flex flex-row flex-wrap p-0 m-0 list-none">
      { children}
    </ul>
  )
}


const PartnerCardMedia = (props) => {
  const { children } = props
  return (
    <CardMedia className="flex items-center content-center h-48 overflow-hidden">
      { children }
    </CardMedia>
  )
}

const PartnerListItem = (props) => {
  const { children } = props;
  return (
    <li className="w-full p-1 sm:w-1/2 md:w-1/3 lg:w-1/4 xl:w-1/5">
      { children }
    </li>
  )
}

const Home = (props) => {
  const {
    partners = {},
  } = props

  // const [{ theme }, dispatch] = useStateValue();
  // const usersRef = firebase.database().ref('/users');

  // useEffect(() => {
  //   usersRef.on('value', (data) => {
  //     console.log('::::::::: ', data);
  //     dispatch({ type: 'TOGGLE_THEME' });
  //     data.forEach((item) => {
  //       console.log(`:::: ${item.key} ${item.val().name}`);
  //     });
  //   });
  //   console.log(':::: useEffect', theme);
  //   return () => {
  //     usersRef.off('value');
  //     console.log(':::: useEffect cancel', dispatch);
  //   }
  // }, []);

  return (
    <div>
      <AppHeaderWrapper>
        <img src={logo} alt="logo" className="mx-auto" />
        <h3>Welcome to ShowDigi Web Projector</h3>
        <br />
        <h5 className="text-xs">version {APP_VERSION}</h5>
      </AppHeaderWrapper>

      <PartnerListContainer>
        { Object.keys(partners)
        .filter(key => partners[key].url)
        .map((key) => {
          const partner = partners[key]
          return (
            <PartnerListItem key={key} >
              <Card>
                <CardHeader
                  title={partner.name}
                  subtitle={partner.url}
                  avatar={partner.photoURL}
                />
                <PartnerCardMedia
                  overlay={
                    <CardTitle
                      title={partner.name}
                    />}
                >
                  <img alt="" src={partner.photoURL} className="mx-auto" />
                </PartnerCardMedia>
                <CardActions>
                  <FlatButton
                    label="Show"
                    containerElement={
                      <Link to={{
                        pathname: `/${partner.url}/projector`,
                        state: { partnerKey: partner.key },
                        }}
                      />
                    }
                    primary
                    icon={<IconNotificationLiveTv />}
                  />

                  <FlatButton
                    label="More..."
                    containerElement={
                      <Link to={{
                        pathname: `/${partner.url}/templates`,
                        state: { partnerKey: partner.key },
                        }}
                      />
                    }
                    secondary
                    icon={<IconActionViewList />}
                  />

                </CardActions>
              </Card>
              {/* </Link> */}
            </PartnerListItem>
          )
        })}
      </PartnerListContainer>
    </div>
  )
}

// eslint-disable-next-line react/prefer-stateless-function
class App extends Component {
  constructor(props) {
    super(props)
    console.log('::::: App props', this.props);
  }
  render() {
    return (
      <MuiThemeProvider muiTheme={getMuiTheme(lightBaseTheme)}>
        <AppWrapper>
          <Receptor />
          <Switch>
            <Route
              exact
              path="/"
              render={routeProps => <Home {...routeProps} {...this.props} />}
            />
            <Route exact path="/lab" component={Lab} />

            <Route
              exact
              path="/:partner/projector"
              render={routeProps => <Projector {...routeProps} />}
            />
            <Route
              exact
              path="/:partner/projector/template/bykey/:templateKey"
              render={routeProps => <Projector {...routeProps} />}
            />
            <Route
              exact
              path="/:partner/projector/template/byname/:templateName"
              render={routeProps => <Projector {...routeProps} />}
            />
            <Route
              exact
              path="/:partner/projector/template/byspot/:spotName"
              render={routeProps => <Projector {...routeProps} />}
            />
            <Route
              exact
              path="/:partner/projector/template/byname/:templateKey"
              render={routeProps => <Projector {...routeProps} />}
            />
            <Route
              exact
              path="/:partner/templates"
              render={routeProps => <Partner {...routeProps} />}
            />
            <Route
              exact
              path="/:partner"
              render={routeProps => <Partner {...routeProps} />}
            />
            <Route
              exact
              path="/:partner/new"
              render={routeProps => <NewParner {...routeProps} />}
            />


            <Route exact path="/remote/:sessionId" component={RemoteControl} />

          </Switch>
        </AppWrapper>
      </MuiThemeProvider>
    );
  }
}

const mapStateToProps = state => ({
  context: state.context,
  presence: state.firebase.data && state.firebase.data.presence,
  profile: state.firebase.profile,
  auth: state.firebase.auth,
  settings: state.settings,
  partners: state.firebase.data && state.firebase.data.rootPartners,
});

const mapDispatchToProps = dispatch => bindActionCreators(commandActions, dispatch)

const ComposedApp = compose(
  firebaseConnect([
    { path: '/partners/', storeAs: 'rootPartners' },
  ]),
  connect(mapStateToProps, mapDispatchToProps, null, {
    context: contextA,
  }),

)(App)

export default withRouter(ComposedApp)



// WEBPACK FOOTER //
// ./src/App.js